<div fxLayout="row" fxLayoutAlign="flex-start center" fxLayoutGap="5px">
  <b>{{details.price | number:'1.2' | currency:'USD'}}</b>
  <div>></div>
  <div><a href="https://store.finalfantasyxiv.com/ffxivstore/en-us/product/{{details.id}}" target="_blank">https://store.finalfantasyxiv.com/ffxivstore/en-us/product/{{details.id}}</a></div>
</div>
